import { Box } from 'theme-ui'

import { isLightBackground } from 'src/lib/styling'

import type { BackgroundColorTypes } from 'src/theme/adSales/colors'

const Background = ({
  backgroundColor,
  children
}: {
  backgroundColor: BackgroundColorTypes
  children: React.ReactNode
}) => {
  return (
    <Box
      as="section"
      sx={{
        background: backgroundColor,
        color: isLightBackground(backgroundColor) ? 'text.primary' : 'text.quaternary'
      }}
    >
      <Box sx={{ variant: 'layout.container', textAlign: 'left' }}>{children}</Box>
    </Box>
  )
}

export default Background
